import { render, staticRenderFns } from "./InputAdmin.vue?vue&type=template&id=2f650d60&scoped=true&"
import script from "./InputAdmin.vue?vue&type=script&lang=js&"
export * from "./InputAdmin.vue?vue&type=script&lang=js&"
import style0 from "./InputAdmin.vue?vue&type=style&index=0&id=2f650d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f650d60",
  null
  
)

export default component.exports